import React from 'react';
import CountUp from 'react-countup';
import SummaryPanel from '@/components/Cluster/SummaryPanel';

export default function Summary({ overview }) {
  const items = [
    {
      title: 'Ledgers',
      icon: 'other2',
      info: <CountUp end={overview.ledgerCount} duration={0.4} />,
    },
    {
      title: 'UnderReplicates',
      icon: 'other3',
      info: <CountUp end={overview.underReplicates} duration={0.4} />,
    },
    {
      title: 'DiskUse',
      icon: 'other4',
      info: <CountUp end={overview.diskUsage} duration={0.4} decimals={2} />,
      unit: '%',
    },
  ];
  return <SummaryPanel shadow={false} img={null} items={items} />;
}
